import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Skeleton from 'react-loading-skeleton'

import { fetchAdminAvailabilityRequestNotifications } from '../../actions/adminActions'
import { AdminHeader } from './Index'
import { AdminTd, AdminTh, AdminTable } from './Tables'

export const AvailabilityRequestNotifications = () => {
  const dispatch = useDispatch()
  const availabilityRequestNotifications = useSelector(store => store.admin.availabilityRequestNotifications)

  useEffect(() => {
    dispatch(fetchAdminAvailabilityRequestNotifications())
  }, [])

  return (
    <div>
      <AdminHeader>AvailabilityRequestNotifications</AdminHeader>

      <AdminTable>
        <thead>
          <tr>
            <AdminTh>Id</AdminTh>
            <AdminTh>User</AdminTh>
            <AdminTh>Notifications</AdminTh>
            <AdminTh>24hrs</AdminTh>
            <AdminTh>Facility</AdminTh>
          </tr>
        </thead>
        {availabilityRequestNotifications.map((obj, index) => (
          <tr key={index} className={obj.id && index % 2 !== 0 && 'bg-green-100'}>
            <AdminTd>{obj.id || <Skeleton width="5ch" />}</AdminTd>
            <AdminTd>{(obj.id && obj.user.email) || <Skeleton width="25ch" />}</AdminTd>
            <AdminTd>{obj.id ? obj.availabilityNotificationsCount : <Skeleton width="4ch" />}</AdminTd>
            <AdminTd>{obj.id ? obj.availabilityNotificationsDayCount : <Skeleton width="4ch" />}</AdminTd>
            <AdminTd>{(obj.id && obj.availabilityRequest.facility.name) || <Skeleton width="40ch" />}</AdminTd>
          </tr>
        ))}
      </AdminTable>
    </div>
  )
}

export default AvailabilityRequestNotifications
